type OperationNationaleInformations = {
  missions_count: number
  participations_count: number
}

export const useOperationNationale = (tag: string) => {
  const isFetchingInformations = ref(false)

  const informations = ref<OperationNationaleInformations>({
    missions_count: 0,
    participations_count: 0,
  })

  const resolveEndpoint = () => {
    if (tag === 'Printemps pour la planète') {
      return `/operations-nationales/printemps-pour-la-planete`
    }
    return `/operations-nationales`
  }

  const fetchInformations = async () => {
    const endpoint = resolveEndpoint()

    await apiFetch(endpoint, {
      params: { tag: tag },
    })
      .then((res) => {
        informations.value = res as OperationNationaleInformations
      })
      .catch((error) => {
        console.log('error', error)
      })
      .finally(() => {
        isFetchingInformations.value = false
      })
  }

  return {
    informations,
    isFetchingInformations,
    fetchInformations,
  }
}
